import { useNavigate } from "react-router-dom";
import React, { useEffect, useState }  from "react";
import Navbar from "./navbar";
import  './Resources/Actions.css';
import './App.css';


export default function Editexpenseshead()
{
    const [expensehead, setExpensehead] = useState([]);
    const [headid,setHeadid] = useState(0);
    const [inputtext , setInputText] = useState(' ');
    const API_URL = process.env.REACT_APP_WEB_API_KEY;
    const navigate = useNavigate();
    const APP_NAME = process.env.REACT_APP_NAME;

    useEffect(()=>{
        fetch(API_URL+"api/Expense/GetExpenseHead")
    .then(response => response.json())
    .then(data => {setExpensehead(data)});
    },[])

    console.log(headid);

    const head = expensehead.filter(el => { 

        if(inputtext ===' ')
        {
          return(el)
        }
        else  
        {
          return el.ExpensesHeadName.toLowerCase().includes(inputtext.toLowerCase())
        }
        })

        function updateheadname()
        {
            fetch(API_URL+"api/Expense/UpdateExpenseHead?id="+headid+"&headname="+document.getElementById('editexpensehead').value,{method:"PUT",body:null})
            .then(res=>res.json())
            .then(()=>{});
        }

    return(
        <>
        <div style={{backgroundColor:"blue", color:"white", height:"30px", width:"100%", 
            paddingTop:"10px", top :"0px", position:"relative", fontFamily:"sans-serif",
            fontSize:"18px",marginBottom:"2%"}}> 
            Update ExpenseHead
            <Navbar/>
        </div> 
            
        <div style={{marginTop:"-10px",position:"sticky",top:"0px",width:"100%"}}>
        <input id = "search" style={{width:"97%",marginBottom:"0px"}} placeholder="Find ExpenseHead" onChange = {(e)=>{setInputText(e.target.value)}} className="searchid" autoFocus></input></div><br/>
        <div style={{width:"99%",height:"100%",marginBottom:"160px",marginTop:"0px"}}>
        {head.map(cus=>{return(
        <div className="customerlist" ><p onClick={(e)=>{setHeadid(cus.ExpensesHeadID);return (document.getElementById('editexpensehead').value = cus.ExpensesHeadName );}}>{cus.ExpensesHeadName}</p><br/>
        </div>)})}</div>
        <fieldset style={{bottom:"0px", position:"fixed",width:"95%",height:"21%",backgroundColor:"skyblue",marginLeft:"-5px"}}>
        <input id = "editexpensehead" style={{width:"97%",marginBottom:"15px"}}  className="searchid" ></input><br/>
        <button className="actionbuttons" type="submit" onClick={()=>{updateheadname();navigate('/changes')}}>Update</button>
        <button className="actionbuttons" style ={{backgroundColor:"red"}} type="submit" onClick={()=>{navigate('/changes')}}>Cancel</button>
        </fieldset>
        </>
    )
}